<template>
  <v-container>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Première ligne pour le deuxième logo -->
    <v-row class="d-flex justify-end align-center mt-2">
      <!-- Logo UM6P à gauche -->
      <v-img
        src="@/assets/UM6PLOGO.png"
        contain
        max-height="50"
        max-width="150"
        class="mr-2"
      ></v-img>
      <!-- Drapeaux à droite avec ml-auto -->
      <v-btn-toggle class="ml-auto">
        <v-btn @click="changerLangue('fr')">
          <v-img
            src="@/assets/france-flag-icon.svg"
            contain
            max-height="25"
          ></v-img>
        </v-btn>
        <v-btn @click="changerLangue('en')">
          <v-img
            src="@/assets/english-flag-icon.svg"
            contain
            max-height="25"
          ></v-img>
        </v-btn>
      </v-btn-toggle>
    </v-row>

    <h1 class="text-center" style="color: #d84a2b">
      {{ this.$storeUniversite.label.CreationCompte }}
    </h1>
    <div v-if="$storeUniversite.Ouvert == false || $storeUniversite.InscriptionFermee == true">
      <h3>La période d'inscription n'est pas ouverte.</h3>
    </div>
    <div v-else-if="$storeUniversite.ChoixCycle.length == 0 || $storeUniversite.NiveauEtude.length == 0">
      <h3>{{$storeUniversite.label.MessageCondidaturesClotures}}.</h3>
    </div>
    <div v-else>
      <p class="text-center">
        {{ this.$storeUniversite.label.PhraseCreationCompte }}
      </p>

      <!-- Carte principale -->
      <v-card class="ma-carte-extranet">
        <InscriptionExtranet ref="childIntroductionComponent" />
      </v-card>

      <!-- Bouton Valider Inscription en bas -->
      <v-btn
        color="success"
        @click="saveForm"
        class="ml-auto mt-2 my-custom-margin"
      >
        {{ $storeUniversite.label.ValiderInscription }}
      </v-btn>
    
    </div>
  </v-container>
</template>

<script>
import InscriptionExtranet from "@/components/InscriptionUniversite/IntroductionComponent.vue";

export default {
  data() {
    return {
      //Réafecter objet global
      $storeUniversite: this.$storeUniversite,
      $storeCatalogue: this.$storeCatalogue,
      loader: false,
      lectureSeule: true,
    };
  },
  components: {
    InscriptionExtranet,
  },
  methods: {
     saveForm() {
      var self = this;
      Promise.all([
        this.$refs.childIntroductionComponent.valider()
      ])
      .then(function () {
        if (self.$storeUniversite.validIntroduction) {
          self.validerInscription();
        }
      });
    },

    validerInscription() {
      var self = this;
      this.loader = true;
      Promise.all([
        this.$storeUniversite
          .InscriptionExtranet(this.$storeUniversite.inscription)
          .then((response) => {
            if (response.data) {
              this.$router.push("/InscriptionPriseEncompte");
            } else {
              this.$router.push("/DejaInscrit");
            }
          })
          .catch((error) => {
            if (error) {
              console.log(error);
              alert(error);
            }
          }),
      ]).then(function () {
        self.loader = false;
      });
    },
    changerLangue(langue) {
      // Mettre à jour la langue des rules
      this.$rules.lang = langue
      if (langue === "en") {
        this.$storeUniversite.label = this.$storeUniversite.labelen;
        this.$storeUniversite.itemLang = "lang01";
      } else {
        this.$storeUniversite.label = this.$storeUniversite.labelfr;
        this.$storeUniversite.itemLang = "lang00";
      }
    },
    // Autres options de votre vue si nécessaire
  },
created(){
    document.title = "Inscription UM6P";
    const baseurl = process.env.VUE_APP_FORMULAIRES;
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.rel = 'icon';
    link.href = baseurl+"um6p.ico";
    document.getElementsByTagName('head')[0].appendChild(link);
  },
  async mounted() {
    this.$storeUniversite.inscription.UtmCampaign = this.$route.query.utm_campaign;
    this.$storeUniversite.inscription.UtmContent = this.$route.query.utm_content;
    this.$storeUniversite.inscription.UtmMedium = this.$route.query.utm_medium;
    this.$storeUniversite.inscription.UtmTerm = this.$route.query.utm_term;
    this.$storeUniversite.inscription.UtmSource = this.$route.query.utm_source;

    this.loader = true;

    await this.$storeCatalogue.ChargerCataloguesInscriptionUniversite();
    const reponse = await this.$storeUniversite.GetParamInscription(null);
    if(reponse && reponse != "error"){
      this.$storeUniversite.MapperParamInscription(reponse);
      this.$storeUniversite.lectureSeule = false;
      this.$storeUniversite.inscription.PaysDeResidence = this.$storeCatalogue.DataId.Maroc;
    }
    
    this.loader = false;
  },
};
</script>

<style scoped src="@/assets/css/DemandeBourse.css">
</style>